import { Component, Inject } from '@angular/core';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISelection } from 'pbc.types';

import { DateiArtsQueryFilterConfig, IDateiArtsQueryShapes } from 'fa-kt.types';
import { DateiArtsService } from '../service';

@Component({
  selector: 'fa-kt-datei-arts-filter',
  templateUrl: './datei-arts-filter.component.html',
  styleUrls: ['./datei-arts-filter.component.css'],
})
export class DateiArtsFilterComponent {
  readonly subscriptions: Subscription[] = [];

  DateiArtsFilterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public dateiArts: DateiArtsService,
  ) {
    this.DateiArtsFilterConfig = DateiArtsQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push(
      this.dateiArts.shapes$.subscribe((shapes: IDateiArtsQueryShapes | undefined) => {
        if (!shapes) {
          return;
        }
        Object.entries(shapes)
          .filter(([key]) => key !== 'id' && (shapes as any)[key])
          .forEach(([key]) => this.shape(key, (shapes as any)[key]));
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.DateiArtsFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.DateiArtsFilterConfig[index].selections = shapes;
  }
}
